import { render, staticRenderFns } from "./chujuSub.vue?vue&type=template&id=2ebc939a&scoped=true"
import script from "./chujuSub.vue?vue&type=script&lang=js"
export * from "./chujuSub.vue?vue&type=script&lang=js"
import style0 from "./chujuSub.vue?vue&type=style&index=0&id=2ebc939a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebc939a",
  null
  
)

export default component.exports